import { useState } from "react";

const useProductAlerts = ({
  setActiveTab,
  INFO_TAB,
  resetState: resetProductSidebarHooksState,
  informationTabProps,
  variantTabProps,
  imageTabProps,
  onDismiss
}) => {
  const onDismissUnMount = (...args) => {
    resetProductSidebarHooksState();
    informationTabProps.resetState();
    variantTabProps.resetState();
    imageTabProps.resetState();
    setActiveTab(INFO_TAB);
    return onDismiss(...args);
  };

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("Are you sure?");
  const [alertConfirmButtonText, setAlertConfirmButtonText] = useState(
    "Confirm"
  );
  const [onAlertConfirm, setOnAlertConfirm] = useState(() => onDismissUnMount);

  const onAlertConfirmClose = (e) => {
    onAlertConfirm(e);
    setIsAlertOpen(false);
  };

  const onAlertCancel = () => setIsAlertOpen(false);

  const onDismissSidebar = (skipAlert) => {
    if (skipAlert === true) {
      onDismissUnMount();
    } else {
      setOnAlertConfirm(() => onDismissUnMount);
      setAlertMessage(
        "Are you sure you want to dismiss without saving? All your changes will be lost."
      );
      setAlertConfirmButtonText("Yes, don't save");
      setIsAlertOpen(true);
    }
  };

  const deleteVariant = (rowIndex) => () => {
    setOnAlertConfirm(() => () => variantTabProps.deleteVariant(rowIndex));
    setAlertMessage("Are you sure you want to delete this Variant?");
    setAlertConfirmButtonText("Yes, delete it");
    setIsAlertOpen(true);
  };

  const deleteVariantOption = (columnIndexToDelete) => () => {
    setOnAlertConfirm(() => () =>
      variantTabProps.deleteVariantOption(columnIndexToDelete)
    );
    setAlertMessage("Are you sure you want to delete this Option?");
    setAlertConfirmButtonText("Yes, delete it");
    setIsAlertOpen(true);
  };

  const onRemoveImage = (indexToRemove) => {
    setOnAlertConfirm(() => () => imageTabProps.onRemoveImage(indexToRemove));
    setAlertMessage("Are you sure you want to delete this Image?");
    setAlertConfirmButtonText("Yes, delete it");
    setIsAlertOpen(true);
  };

  return {
    onDismissSidebar,
    alertConfirmButtonText,
    isAlertOpen,
    onAlertCancel,
    onAlertConfirm: onAlertConfirmClose,
    alertMessage,
    deleteVariant,
    deleteVariantOption,
    onRemoveImage
  };
};

export default useProductAlerts;
